import { render, staticRenderFns } from "./community-edit.vue?vue&type=template&id=44847564&scoped=true&"
import script from "./community-edit.vue?vue&type=script&lang=js&"
export * from "./community-edit.vue?vue&type=script&lang=js&"
import style0 from "./community-edit.vue?vue&type=style&index=0&id=44847564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44847564",
  null
  
)

export default component.exports